var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "full-size" }, [
    _c("div", { staticClass: "fix-top" }, [
      _c("div", { staticClass: "nav-box" }, [
        _c("ul", [
          _c("li", [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.topage({ path: "/" })
                  }
                }
              },
              [_vm._v("主页")]
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.topage({ path: "/product" })
                  }
                }
              },
              [_vm._v("产品列表")]
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "active" }, [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.topage({ path: "/news" })
                  }
                }
              },
              [_vm._v("理财资讯")]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "main" },
      [
        !_vm.isNewsInit
          ? [_vm._m(0)]
          : [
              _vm.newsList && _vm.newsList.length > 0
                ? _c("div", { staticClass: "news-main" }, [
                    _c("div", { ref: "main", staticClass: "left-box" }, [
                      _c(
                        "ul",
                        _vm._l(_vm.newsList, function(item, index) {
                          return _c("li", { key: index }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0);" },
                                on: {
                                  click: function($event) {
                                    return _vm.toDetail(item)
                                  }
                                }
                              },
                              [
                                _c("p", [_vm._v(_vm._s(item.Title))]),
                                _c("span", [
                                  _vm._v(_vm._s(item.shortCreateDate))
                                ])
                              ]
                            )
                          ])
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _vm.tempItem.LinkUrl && _vm.tempItem.LinkUrl.length > 0
                      ? _c("div", { staticClass: "right-box" }, [
                          _c("iframe", {
                            ref: "iframe",
                            attrs: {
                              src: _vm.tempItem.LinkUrl,
                              width: "100%",
                              height: "100%",
                              frameborder: "0",
                              scrolling: "no"
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                : _c("div", { staticClass: "no-data" }, [_vm._m(1)])
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-data" }, [
      _c("div", { staticClass: "no-inner" }, [
        _c("i", { staticClass: "icon" }),
        _vm._v(" "),
        _c("p", [_vm._v("数据加载中")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-inner" }, [
      _c("i", { staticClass: "icon" }),
      _vm._v(" "),
      _c("p", [_vm._v("暂无数据")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7255f852", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7255f852","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/news.vue
// module id = null
// module chunks = 